export const assignation = {
    columns: {
        default: ['assigned_node_title', 'start_date', 'assigned_user', 'buttons']
    },
    columnsDashboardWidget: {
        default: ['assigned_node_title', 'start_date', 'assigned_user', 'consulted']
    },
    completionStartDateOnly: ['*'],
    displayNews: {
        default : [],
        trainer: ['createNoAssignmentForLongTimeAgo']
    },
    filters: {
        default: ['title', 'group', 'workgroup', 'learner', 'type'],
        learner: []
    },
    formFields : {
        default : ['group', 'workgroup', 'learner', 'start_date', 'assignment_type'],
    },
    followedLogBookFields: {
        default: ['group', 'type', 'exoName', 'learner', 'beginDate', 'endDate'],
        learner: []
    },
    hasCompletionDate: false,
    hasCompletionTime: false,
    hasType: true,
    checkDefaultFiltersInUrl: true,
    stateWithIcon: false,
    noFilterforAssignmentsWidget: true,
    showHours: false
};
